import { RcButton, styled } from '@ringcentral/juno';
import { useProximaNovaSemibold } from '@/core/sc';

export const StyledButton = styled(RcButton)`
  ${useProximaNovaSemibold};
  margin-top: 20px;
`;
